import { useState } from "react";
import Product from "./SaleProducts";
import { Container } from "react-bootstrap";
import SkeletonShow from "../../Skeleton/SkeletonShow";

export default function ShowLatestSaleProducts() {
  const [products] = useState([]);
  const [loading] = useState(false);

  const productsShow = products.map((product) => (
    <Product
      key={product.id}
      title={product.title}
      description={product.description}
      img={product.images[0]?.image}
      price={product.price}
      discount={product.discount}
      rating={product.rating}
      id={product.id}
      col="3"
    />
  ));

  return (
    <Container id="excellent-student">
      {/* <h1>أساتذة الفرع العلمي</h1>
      <div className="d-flex align-items-stretch justify-content-center flex-wrap row-gap-2 mb-5">
        {loading ? (
          <SkeletonShow height="300px" length={4} classes="col-lg-3 col-md-6 col-12" />
        ) : (
          productsShow
        )}
      </div>
      <h1>أساتذة الفرع الادبي</h1>
      <div className="d-flex align-items-stretch justify-content-center flex-wrap row-gap-2 mb-5">
        {loading ? (
          <SkeletonShow height="300px" length={4} classes="col-lg-3 col-md-6 col-12" />
        ) : (
          productsShow
        )}
      </div>
      <h1>أساتذة التاسع الأساسي</h1>
      <div className="d-flex align-items-stretch justify-content-center flex-wrap row-gap-2 mb-5">
        {loading ? (
          <SkeletonShow height="300px" length={4} classes="col-lg-3 col-md-6 col-12" />
        ) : (
          productsShow
        )}
      </div> */}
    </Container>
  );
}
